import React, {useCallback} from 'react';
import {SysPath} from 'SysContext';
import {RAjax} from '@putil-view/request.r-ajax';
import {RSpinner} from '@putil-view/item.components';
import PropTypes from 'prop-types';
export const UploadUnlockData = ({state,setState, uuid})=>{

	const handleUploaded = useCallback((output) =>{
		if(output){
			[state.lockerImage, state.lockerItems,state.lockerVideo, state.lockerVideoUrl].forEach((blob) => {
				if (blob) {
					URL.revokeObjectURL(blob);
				}
			})
			setState(prevState =>{ return{...prevState , ...{result:output.result, stage:"DISPLAY_RESULT"}}});
		}
	},[setState, state.lockerImage, state.lockerItems,state.lockerVideo, state.lockerVideoUrl])

	const dataURLtoBlob = (dataurl) => {
		var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
		while(n--){
				u8arr[n] = bstr.charCodeAt(n);
		}
		return new Blob([u8arr], {type:mime});
	}

	const addUnlockRecordUrl = SysPath.addUnlockRecordUrl;
	const final_data = {...state.info};
	let formData = new FormData();
	formData.append('uuid', uuid.current);
	formData.append('final_data',JSON.stringify(final_data));
	formData.append('file', dataURLtoBlob(state.lockerImage),'lockerImage.jpg');
	formData.append('file', dataURLtoBlob(state.lockerItems),'lockerItems.jpg');
	formData.append('file', state.lockerVideo,'lockerVideo.mp4');
	
	return (
		<>
			<RAjax requestOptions={{
						method: 'post',
						withCredentials: true,
						headers: {
							"Content-Type": "application/json"
						},
						url: addUnlockRecordUrl,
						data: formData
					}}
					handleResponse={handleUploaded}
			/>

			<span className="text-center" style={{width:'700px', height:'700px'}}> <RSpinner/></span>
			<h5 className="text-center">Uploading Unlock Images</h5>
		</>
	)
}

UploadUnlockData.propTypes = {
	state:PropTypes.object,
	setState: PropTypes.func,
	uuid: PropTypes.oneOfType([
		PropTypes.func, 
		PropTypes.shape({ current: PropTypes.string })
	])
};

